import { render, staticRenderFns } from "./users-listing.vue?vue&type=template&id=70bf5f18&"
import script from "./users-listing.vue?vue&type=script&lang=js&"
export * from "./users-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports